// src/context/AuthContext.jsx
import { createContext, useState, useContext, useCallback } from "react";

const AuthContext = createContext();
const API_URL = process.env.REACT_APP_API_URL || "";

export function AuthProvider({ children }) {
  const [authHeader, setAuthHeader] = useState(
    localStorage.getItem("authHeader")
  );

  // Llamada de login: prueba credenciales contra /auth
  const login = async (username, password) => {
    const res = await fetch(`${API_URL}/auth`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
      credentials: "include"
    });
  
    if (!res.ok) throw new Error("Usuario o contraseña inválidos");
  
    // si fue OK, guardamos el header Basic
    const header = "Basic " + btoa(`${username}:${password}`);
    localStorage.setItem("authHeader", header);
    setAuthHeader(header);
  
    return username;
  };

  const logout = () => {
    localStorage.removeItem("authHeader");
    setAuthHeader(null);
  };

  // wrapper para todas las fetch posteriores
    const authFetch = useCallback((url, opts = {}) =>
        fetch(`${API_URL}${url}`, {
        ...opts,
        headers: {
            ...(opts.headers || {}),
            Authorization: authHeader,
        },
        credentials: "include"
    }),[authHeader]);

  return (
    <AuthContext.Provider value={{ authHeader, login, logout, authFetch }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
